module.exports = __webpack_public_path__ + "static/media/veneto-3-14.45e6f0bd.jpg";